import { render, staticRenderFns } from "./GoodsInfoLabels.vue?vue&type=template&id=6ca58756&scoped=true"
import script from "./GoodsInfoLabels.vue?vue&type=script&lang=js"
export * from "./GoodsInfoLabels.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoLabels.vue?vue&type=style&index=0&id=6ca58756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca58756",
  null
  
)

export default component.exports